import { motion } from "framer-motion"; // Import Framer Motion
import TitleBar from "../../TitleBar/TitleBarWithoutDivider";
import TitleWithContent from "../../titlewithcontent(without divider)/TitleWithContentWithoutDivider";
import Paragraph from "@/components/elements/Paragraph/Paragraph";
import CustomLists from "@/components/elements/CustomLists/CustomLists";

const PrivacyPolicy = () => {
  return (
    <div className="bg-custom-background pb-0 px-0 sm:px-1 2xl:px-40 xl:px-40 md:px-[3rem] ">
      <div className="pt-10">
        <motion.div
          initial={{ opacity: 0, scaleX: 0 }}
          animate={{ opacity: 1, scaleX: 1 }}
          transition={{ duration: 0 }}
        >
          <TitleBar title="Privacy Policy" />
        </motion.div>
      </div>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={{
          hidden: { opacity: 0 },
          visible: { opacity: 1, transition: { staggerChildren: 0.7, opacity: { duration: 0 } } },
        }}
      >
        <TitleWithContent title="Introduction">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="At Sheel Waterproofing Nepal Pvt. Ltd., we are committed to protecting your privacy. This Privacy Policy outlines how we collect, use, and protect your personal information." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Information We Collect">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <CustomLists
            layout="stacked"
              items={[
                [
                  "Personal identification information (name, email address, phone number).",
                  "Technical data such as IP address, browser type, and device information.",
                  "Usage data related to how you interact with our website.",
                ],
              ]}
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="How We Use Your Information">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <CustomLists
            layout="stacked"
              items={[
                [
                  "To respond to your inquiries and provide customer support.",
                  "To improve our website, services, and user experience.",
                  "To send promotional emails (only if you opt-in).",
                ],
              ]}
            />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Data Protection">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="We implement industry-standard security measures to protect your data from unauthorized access, alteration, or disclosure." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Third-Party Sharing">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="We do not sell or rent your personal information. We may share your data only with trusted third parties who assist us in operating our website or providing services, under strict confidentiality agreements." />
          </motion.div>
        </TitleWithContent>

        <TitleWithContent title="Your Rights">
          <motion.div
            variants={{
              hidden: { opacity: 0, scale: 0.8 },
              visible: { opacity: 1, scale: 1 },
            }}
            transition={{
              duration: 0,
              ease: "easeOut",
              scale: { type: "spring", stiffness: 100, damping: 10 },
            }}
          >
            <Paragraph content="You have the right to access, update, or delete your personal data. To exercise these rights, please contact us at the email below." />
          </motion.div>
        </TitleWithContent>
      </motion.div>
    </div>
  );
};

export default PrivacyPolicy;
